// extracted by mini-css-extract-plugin
module.exports = {"container":"_1XCuxLij8a4XMzDEQiRwtQ","restaurantsList":"_1Qp3vPYm_uB98ZSZcTTFeE"};